export const sendGTMEvent = (event, params = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({ event, ...params });
    console.info('pushing to data layer', event);
  } else {
    console.warn('Couldn\'t find \'dataLayer\' object. Make sure that that GTA is added before sending events');
  }
};
